export const getFullName = (firstName, lastName) => {
    return firstName + ' ' + lastName;
}

export const timer = (ms) => new Promise((res) => setTimeout(res, ms));
